module.exports = __webpack_public_path__ + "img/5.e66201c2.webp";